<template>
    <button 
        class="flat-icon-button"
        @click="onClick"
        :disabled="disabled"
        :style="{
            '--icon-size': iconSize + 'px'
        }"
    >
        <span v-if="text" class="button__text">{{ text }}</span>
        <template v-if="loading">
            <LoadingSpinner :size="iconSize" />
        </template>
        <template v-else>
            <slot name="svgIcon"></slot>
        </template>
    </button>
</template>

<script>
import LoadingSpinner from '@/components/ui/loading/loadingSpinner.vue';

export default {
    name: 'flatIconButton',
    components: {
        LoadingSpinner
    },
    props: {
        text: {
            type: String,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        iconSize: {
            type: Number,
            default: 16
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onClick() {
            this.$emit('click');
        }
    }
}
</script>

<style scoped>

.flat-icon-button {
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-xs);
    padding: 0;
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    color: var(--color-primary);
    transition: all 0.3s ease;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
}

.flat-icon-button:hover:not(:disabled) {
    opacity: 0.7;
}

.flat-icon-button:disabled {
    opacity: 0.5;
    color: var(--color-dark-gray);
    cursor: not-allowed;
}

.button__text {
    max-width: 0;
    opacity: 0;
    overflow: hidden;
    transition: max-width 0.3s ease, opacity 0.3s ease, margin 0.3s ease;
    margin: 0;
    font-weight: 600;
    font-size: 11px;
    color: var(--color-primary);
}

.flat-icon-button:hover .button__text {
    max-width: 200px;
    opacity: 1;
    margin-right: 0;
}

.flat-icon-button svg {
    width: var(--icon-size);
    height: var(--icon-size);
    flex-shrink: 0;
}
</style>